import React from 'react';
interface CardProps {
  children: ReactNode;
  title?: string;
  subtitle?: string;
  action?: ReactNode;
  className?: string;
  padding?: 'none' | 'sm' | 'md' | 'lg';
}
const Card = ({
  children,
  title,
  subtitle,
  action,
  className = '',
  padding = 'md'
}: CardProps) => {
  const paddingStyles = {
    none: 'p-0',
    sm: 'p-3',
    md: 'p-4',
    lg: 'p-6'
  };
  return <div className={`bg-white rounded shadow-card ${paddingStyles[padding]} ${className}`} data-id="element-69">
      {(title || action) && <div className="flex justify-between items-start mb-4" data-id="element-70">
          <div data-id="element-71">
            {title && <h3 className="font-medium" data-id="element-72">{title}</h3>}
            {subtitle && <p className="text-sm text-neutral-400 mt-1" data-id="element-73">{subtitle}</p>}
          </div>
          {action && <div data-id="element-74">{action}</div>}
        </div>}
      {children}
    </div>;
};
export default Card;